// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    firebaseConfig: {
        apiKey: 'AIzaSyARLA0cuSwUBTEGk9FjFZlxMMgh9MESplM',
        authDomain: 'date-min-dude.firebaseapp.com',
        databaseURL: 'https://date-min-dude.firebaseio.com',
        projectId: 'date-min-dude',
        storageBucket: 'date-min-dude.appspot.com',
        messagingSenderId: '437044973900',
        appId: '1:437044973900:web:b62a9bf28cc463e150bfe9',
        measurementId: 'G-PES8JGSRDB'
    },
    API_URL: 'https://us-central1-date-min-dude.cloudfunctions.net/api/v1.0/web/',
    SECRET_KEY : 'dmd-prod-secret-key'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
